import type { RootState } from '../reducers/rootReducer.ts';

export const companiesSelector = (state: RootState) => state.companyReducer.companies;
export const companiesAreLoadingSelector = (state: RootState) => state.companyReducer.companiesAreLoading;
